import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

const initialState = {
  first_name: "",
  last_name: "",
  email: "",
  password1: "",
  password2: "",
};

class RegisterTwo extends Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = initialState;
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    this.props.authDrawerActions.setBasicInfo(this.state).then(() => {
      if (!this.props.authDrawer.emailAvailable) {
        return alert("Email is not available");
      }

      this.setState(initialState);
      this.changeStep(authDrawerConstants.REGISTER3);
    });
  }

  changeStep(step, event) {
    if (event) {
      event.preventDefault();
    }

    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <h3>Register with email</h3>

        <form onSubmit={this.handleSubmit}>
          <div className={styles.marginTop40}>
            <input
              onChange={this.handleChange}
              name="first_name"
              type="text"
              placeholder="First name"
              value={this.state.first_name}
            />
          </div>
          <div className={styles.marginTop20}>
            <input
              onChange={this.handleChange}
              name="last_name"
              type="text"
              placeholder="Last name"
              value={this.state.last_name}
            />
          </div>
          <div className={styles.marginTop20}>
            <input
              onChange={this.handleChange}
              name="email"
              type="email"
              placeholder="Email"
              value={this.state.email}
            />
          </div>
          <div className={styles.marginTop20}>
            <input
              onChange={this.handleChange}
              name="password1"
              type="password"
              placeholder="Create a password"
              value={this.state.password1}
            />
          </div>
          <div className={styles.marginTop20}>
            <input
              onChange={this.handleChange}
              name="password2"
              type="password"
              placeholder="Confirm your password"
              value={this.state.password2}
            />
          </div>

          <div className={styles.nextButton}>
            <button
              type="submit"
              className={classNames(
                styles.blueButton1,
                styles.block,
                styles.centered
              )}
            >
              Next
              <Icon name="chevron/right" className={styles.icon} />
            </button>
          </div>
        </form>

        <div className={classNames(styles.marginTop40, styles.textCenter)}>
          Already an Axios member?{" "}
          <a
            onClick={this.changeStep.bind(this, authDrawerConstants.SIGNIN)}
            href="#"
            className={classNames(styles.blackLink, styles.bold)}
          >
            Sign in now.
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterTwo);
